import styled from "styled-components";
import { BodySmall, HeadLine1 } from '../../../components/typography/styled'
import {
  responsiveDetailActions,
  responsiveDetailContainer,
  responsiveDetailHeader,
  responsiveDetailMeta,
  responsiveDetailNav,
  responsiveDetailTitle,
} from '../../../components/tabs/detail-layout'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px 30px 30px 20px;
  /* position: relative; */
  ${responsiveDetailContainer}
`
export const HeadWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width:100%;
  ${responsiveDetailHeader}
`

export const RightHeadContainer = styled.div`
  display:flex;
  position: relative;
  ${responsiveDetailActions}
`

export const InstanceName = styled(HeadLine1)`
  color:${({theme}) => theme.palette[800]};
  word-break:break-all;
  margin-top:10px;
  margin-bottom:10px;
  ${responsiveDetailTitle}
`
export const NavWrapper = styled.div`
  border-bottom: ${({theme}) => `1px solid ${theme.grey[350]}`};
  position: relative;
  width: 100%;
  display: flex;
  margin-top:50px;
  &>div{
    position: absolute;
    bottom:-1px;
    left:0px;
  }
  ${responsiveDetailNav}
`
export const InstanceHeadInfo = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  ${responsiveDetailMeta}
`
